import { useState } from 'react';
import { Button, Flex, Modal, Spin, Tooltip, Typography } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useGetClientCargoGeo } from 'client-app/api/client-cargoes/use-get-client-cargo-geo';
import { ClientCargoMapContainer } from '../client-cargo-map-container';
import styles from './cargo-map-modal.module.scss';
import type { ICargoMapModalProps } from './types';

export const CargoMapModal: React.FC<ICargoMapModalProps> = ({ cargoId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data: cargoGeo, isLoading } = useGetClientCargoGeo(cargoId, {
    enabled: isModalOpen,
  });

  const showModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <Tooltip title='Transport geo position' placement='bottom'>
        <Button icon={<GlobalOutlined />} onClick={showModal} />
      </Tooltip>
      <Modal title='Geo' open={isModalOpen} footer={null} className={styles.modal} width='50%' onCancel={closeModal}>
        {isLoading && (
          <Flex justify='center' align='center' className={styles.noContentAndLoaderWrapper} vertical>
            <Spin size='large' />
          </Flex>
        )}
        {!isLoading && !cargoGeo && (
          <Flex justify='center' align='center' className={styles.noContentAndLoaderWrapper} vertical>
            <Typography.Text type='secondary'>No trips were found.</Typography.Text>
          </Flex>
        )}
        {!isLoading && cargoGeo && (
          <ClientCargoMapContainer waypoints={cargoGeo?.waypoints} transport={cargoGeo?.transport} />
        )}
      </Modal>
    </>
  );
};
